import fr from 'facet-rest';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import IncomeStepOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeStep/MetaOverride';

const IncomeSalaryOverride = fr.metaOverride({ base: IncomeStepOverride })
  .nameOverride('descriptionTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
      color: 'textDisabled',
    },
  }, overrideReadOnly)
  .nameOverride('payStubs', {
    hidden: true,
  }, overrideReadOnly);

export { IncomeSalaryOverride };
